import { Injectable } from '@angular/core';
import { UrlHandlingStrategy } from '@angular/router';

@Injectable()
export class Configuration {
    public _local: boolean = false;
    public _debug: boolean = false;
    public _dev: boolean = false;
    public _tokenIdentifier: string = "";
    public virtualUrl: string = "";
    public _subdomainhost:string="http://kyocera.cloudrevenue.it/login";
    constructor() {
        if (this._local) {
            //this.baseUrlToken = "http://127.0.0.1:8080";
            //this.baseUrlToken = "http://localhost:52594";
           //this.baseUrlToken = "http://revoco.azurewebsites.net";
             this.baseUrlToken="https://www.cloudrevenue.it";
             //this.baseUrlToken="http://156.38.138.124/";
        }
        else {
            //this.baseUrlToken = "http://127.0.0.1:8080";
            //this.baseUrlToken = "http://localhost:52594";
            //this.baseUrlToken = "http://revoco.azurewebsites.net";
            this.baseUrlToken="https://www.cloudrevenue.it";
            //this.baseUrlToken="http://156.38.138.124/";
        }
        this._tokenIdentifier = "Authorization";
        //console.log("baseUrl:" + this.baseUrlToken);
    }
    public baseUrlToken: any = {};
}